export const PROGRESS_BAR_STEPS = {
  FIND_YOUR_CAR: 1,
  MODS_ACCESSORIES: 2,
  CAR_DETAILS: 3,
  DRIVER_DETAILS: 4,
  YOUR_QUOTE: 5,
};
